<template>
  <div class="lemma">
    <div v-if="loading">
      <b-container fluid="xxl">
        <b-row class="justify-content-md-center">
            <b-col class="mt-5">
              <div class="spinner-border m-5" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container v-else-if="loadError" fluid="xxl" class="mt-4">
      <b-alert show variant="danger">{{ loadError }}</b-alert>
    </b-container>
    <div v-else-if="lemma">
      <b-container fluid="xxl">
        <b-row>
          <b-col class="pl-0">
            <PageTitle v-bind:title="lemmaDisplay" :pretitle="this.$t('LemmaDetails')" />
          </b-col>
          <b-col>
            <!-- <div class="mt-5 text-right">
              <span v-if="editMode">
                <button @click="saveEdit" class="btn-legam-xs mb-2 btn-primary">
                  <b-icon icon="lock-fill"></b-icon>
                  Save changes
                </button>
                <button @click="cancelEdit" class="btn-legam-xs mb-2">
                  Cancel
                </button>
                <button @click="deleteItem" class="btn-legam-xs mb-2 btn-danger">
                  <b-icon icon="trash2-fill"></b-icon>
                  Delete
                </button>
              </span>
              <span v-else>
                <button @click="editMode = true" class="btn-legam-xs mb-2">
                  <b-icon icon="unlock-fill"></b-icon>
                  Unlock editing
                </button>
              </span>
            </div> -->
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid="xxl">
        <b-row class="justify-content-md-center">
          <b-col v-if="lemma.articleId">
            <router-link :to="{ name: 'Article', params: {id: lemma.articleId}}" class="">
              <b-button size="sm" class="mr-1" variant="light">
                <b-icon icon="book" aria-hidden="true" class="mr-1"></b-icon>
                {{ $t('ArticleDetails') }} (<b v-html="lemma.articleMainLemmaForm"></b>)
              </b-button>
            </router-link>
          </b-col>
          <!-- <b-col lg="4">
            <LemmaArticleTree v-bind:lemmaId="lemmaId" :key="articleKey" />
          </b-col> -->
        </b-row>
        <b-row class="justify-content-md-center">
          <b-col>
            <LemmaEditDetails :lemmaObj="lemma" :hideTitle="true" @update="updateArticle" :showCloseButton="false" />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import router from '@/router'
  import PageTitle from '@/components/PageTitle.vue'
  import LemmaEditDetails from '@/components/Lemma/EditDetails.vue'
  // import LemmaArticleTree from '@/components/Lemma/ArticleTree.vue'

  export default {
    name: 'Lemma',
    data() {
      return {
        lemmaId: this.$route.params.id,
        loading: true,
        loadError: null,
        editMode: false,
        articleKey: 0
      }
    },
    computed: {
      ...mapState({
        lemma: state => state.lemma.lemma
      }),
      lemmaDisplay(){
        let prefix = ''
        if (this.lemma.scriptas.length){
          prefix = `<small>${this.lemma.scriptas.map(scripta => scripta.code).join(', ')}</small> `
        }
        if (this.lemma.isReconstructed){
            prefix = `${prefix}*`
          }
        let sufix = ''
        if (this.lemma.partofspeeches.length){
          sufix = ` <small>${this.lemma.partofspeeches.map(partofspeeche => partofspeeche.name).join(', ')}</small>`
        }
        let etymon = ''
        if (this.lemma.etymon && !this.lemma.articleId){
          etymon = ` <small>(${this.lemma.etymonChain})</small>`
        }
        return `${prefix}${this.lemma.lemmaForm}${sufix}${etymon}`
      }
    },
    watch: {
      '$route.params.id'(id) {
        this.lemmaId = id
        this.loadLemma()
      }
    },
    mounted(){
      this.loadLemma()
    },
    components: {
      PageTitle,
      LemmaEditDetails,
      // LemmaArticleTree
    },
    methods: {
      async loadLemma(){
        this.loading = true
        this.loadError = null
        try {
          await this.$store.dispatch('loadLemma', this.lemmaId)
        } catch (error) {
          this.loadError = error.response && error.response.status === 404
            ? `Lemma ${this.lemmaId} was not found`
            : error.message || `Lemma ${this.lemmaId} could not be loaded`
        } finally {
          this.loading = false
        }
      },
      cancelEdit(){
        this.editMode = false
      },
      saveEdit(){
        this.editMode = false
        this.$store.dispatch('addNotification', {
          type: 'warning',
          text: `Not implemented yet`
        })
      },
      deleteItem(){
        this.$bvModal.msgBoxConfirm('Are you sure?').then(value => {
          if (value){
            this.$store.dispatch('deleteLemma', this.lemma).then(() => {
              router.push('/lemmas')
            })
          }
        })
      },
      updateArticle(){
        this.articleKey++
      }
    }
  }
</script>
